import Model from '../utils/Model'

export class CargoDocCfmState {
  constructor(code, englishName, chineseName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'CustomsDeclareType'

export const CARGODOC_CFM_STATE_WKS = new CargoDocCfmState(0, 'To be started', '未开始')
export const CARGODOC_BLI_STATE_WQF = new CargoDocCfmState(0, 'To be started', '未签发')
export const CARGODOC_CFM_STATE_DHD = new CargoDocCfmState(1, 'To be invited', '未邀请')
export const CARGODOC_CFM_STATE_ZDD = new CargoDocCfmState(2, 'To be confirmed', '待确认')
export const CARGODOC_CFM_STATE_YQR = new CargoDocCfmState(3, 'confirmed', '已确认')
export const CARGODOC_CFM_STATE_SQDD = new CargoDocCfmState(4, 'Apply to check bills', '客人申请对单')
export const CARGODOC_CFM_STATE_CMPFEED = new CargoDocCfmState(5, 'Confirmed bills', '已补料')
export const CARGODOC_CFM_STATE_EXCEPTION = new CargoDocCfmState(6, 'Abnormal bills', '对单异常')
export const CARGODOC_CFM_STATE_GET_BACKED = new CargoDocCfmState(7, 'Get back', '已取回')
export const CARGODOC_CFM_STATE_RECEIVED = new CargoDocCfmState(8, 'Received', '已接收')
export const CARGODOC_CFM_STATE_CLAIMED = new CargoDocCfmState(9, 'Claimed', '已认领')
export const CARGODOC_CFM_STATE_RELEASED = new CargoDocCfmState(10, 'Released', '已放单')
export const CARGODOC_CFM_STATUS_CONFIRMED = new CargoDocCfmState(11, 'Bill of lading confirmed', '提单确认中')
export const CARGODOC_BLI_STATUS_ISSUED = new CargoDocCfmState(12, 'Issued', '已签发')
export const CARGODOC_BLI_STATUS_CHANGE = new CargoDocCfmState(13, 'Changing order', '改单中')
export const CARGODOC_CFM_STATE_DOCUMENT_MAKING = new CargoDocCfmState(14, 'Document Making', '制单中')
export const CARGODOC_CFM_STATE_SHIPPER_CONFIRMED = new CargoDocCfmState(15, 'Shipper Confirmed', 'SHIPPER已确认')
export const CARGODOC_CFM_STATE_OVERSEA_FEEDBACK = new CargoDocCfmState(16, 'Oversea Feedback', '海外代理反馈')

// ======提单操作状态
// 未开始
export const OPERATE_HAVE_NOT_STARTED = '0'
// 可放单
export const CARGODOC_CAN_SINGLE_RELEASE = '1'
// 撤销审核
export const CARGODOC_CANCEL_APPROVE = '-1'
// 待确认
export const CARGODOC_WAIT_FOR_CONFIRM = '2'
// 已确认
export const CARGODOC_CONIRMED = '3'
// 已扣单
export const CARGODOC_DETAIN = '4'
// 已取回
export const CARGODOC_GET_BACK = '7'
// 撤销取回
export const CARGODOC_CANCEL_GET_BACK = '-7'
// 已接收
export const CARGODOC_RECEIVED = '8'
// 撤销接收
export const CARGODOC_CANCEL_RECEIVED = '-8'
// 已认领
export const CARGODOC_CLAIMED = '9'
// 撤销认领
export const CARGODOC_CANCEL_CLAIMED = '-9'
// 已退还(点击【放单】动作)
export const CARGODOC_RETURN = '10'
// 撤销退还(点击【撤销放单】动作)
export const CARGODOC_CANCEL_RETURN = '-10'

// 提单确认中
export const CARGODOC_CONFIRMED = '11'
// 已签发
export const CARGODOC_ISSUED = '12'
// 改单中
export const CARGODOC_CHANGE = '13'
// 制单中
export const DOCUMENT_MAKING = '14'
// SHIPPER已确认
export const SHIPPER_CONFIRMED = '15'
// 海外代理反馈
export const OVERSEA_FEEDBACK = '16'

export const CFM_STATES = new Set([
  CARGODOC_CFM_STATE_WKS, CARGODOC_CFM_STATE_DHD,
  CARGODOC_CFM_STATE_ZDD, CARGODOC_CFM_STATE_YQR,
  CARGODOC_CFM_STATE_SQDD, CARGODOC_CFM_STATE_CMPFEED,
  CARGODOC_CFM_STATE_EXCEPTION, CARGODOC_CFM_STATE_GET_BACKED,
  CARGODOC_CFM_STATE_RECEIVED, CARGODOC_CFM_STATE_CLAIMED,
  CARGODOC_CFM_STATE_RELEASED, CARGODOC_CFM_STATUS_CONFIRMED,
  CARGODOC_BLI_STATUS_ISSUED, CARGODOC_BLI_STATUS_CHANGE,
  CARGODOC_CFM_STATE_DOCUMENT_MAKING, CARGODOC_CFM_STATE_SHIPPER_CONFIRMED,
  CARGODOC_CFM_STATE_OVERSEA_FEEDBACK
])

export const BLI_STATES = new Set([
  CARGODOC_BLI_STATE_WQF, CARGODOC_CFM_STATE_GET_BACKED,
  CARGODOC_CFM_STATE_RECEIVED, CARGODOC_CFM_STATE_CLAIMED,
  CARGODOC_BLI_STATUS_ISSUED, CARGODOC_BLI_STATUS_CHANGE
])

export const CFM_MBL_STATES = new Set([
  CARGODOC_CFM_STATE_WKS,
  CARGODOC_CFM_STATE_ZDD, CARGODOC_CFM_STATE_YQR,
  CARGODOC_CFM_STATE_GET_BACKED,
  CARGODOC_CFM_STATE_RECEIVED, CARGODOC_CFM_STATE_CLAIMED,
  CARGODOC_CFM_STATE_RELEASED
])

/**
 *  return null:没找到.
 */
export function getCargoDocCfmStateByCode(code) {
  return Model.getObjByCode(code, CFM_STATES)
}
/**
 * 提单签发状态
 *  return null:没找到.
 */
export function getCargoDocBliStateByCode(code) {
  return Model.getObjByCode(code, BLI_STATES)
}

/**
 * 获取名称
 */
export function getCargoDocCfmStateByName(code, field) {
  if (field === null || field === '') field = 'chineseName'
  const docCfmState = Model.getObjByCode(code, CFM_STATES)
  return docCfmState ? docCfmState[field] : ''
}
